import Group from 'components/utils/Group'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import Label from 'LuxKit/Label'
import BodyText from 'LuxKit/Typography/BodyText'
import styled from 'styled-components'
import { rem } from 'polished'
import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

const SpecialOfferGroup = styled(Group)`
  margin-top: ${rem(4)};
`

const InfiniteSpecialOfferLabel = styled(Label)`
  &&& {
    background: ${props => props.theme.palette.product.loyalty.infinite.gradientPrimaryBackground};
    border-color: ${props => props.theme.palette.product.loyalty.infinite.normalForeground};
  }

  > * {
    background: ${props => props.theme.palette.product.loyalty.infinite.gradientTertiaryBackground};
    background-clip: text;
    color: transparent;
    -webkit-background-clip: text;
  }
`

interface MaldivesFnfSpecialOfferLabelProps {
  children?: ReactNode
  isInfiniteMember?: boolean
}

export function MaldivesFnfSpecialOfferLabel({
  children,
  isInfiniteMember = false,
}: MaldivesFnfSpecialOfferLabelProps) {
  if (isInfiniteMember) {
    return (
      <InfiniteSpecialOfferLabel kind="primary" variant="highlight" format="propercase">
        <FormattedMessage
          id="h6W_QYlt_f9Su7I8CGde"
          defaultMessage="Infinite Member Price"
          
        />
      </InfiniteSpecialOfferLabel>
    )
  }

  return (
    <Label kind="primary" variant="highlight" format="propercase">
      {children ?? (
        <FormattedMessage
          id="15vWM49_cySUYJZ1ydW5"
          defaultMessage="Friends & Family Offer"
          
        />
      )}
    </Label>
  )
}

interface Props {
  fnfInventoryMessage: string
  isHorizontal?: boolean
  isInfiniteMember?: boolean
}

function MaldivesFnfSpecialOffer({
  fnfInventoryMessage,
  isHorizontal = false,
  isInfiniteMember = false,
}: Props) {
  return (
    <SpecialOfferGroup direction={isHorizontal ? 'horizontal' : 'vertical'} horizontalAlign="center" verticalAlign="center" gap={4}>
      <MaldivesFnfSpecialOfferLabel isInfiniteMember={isInfiniteMember} />
      {fnfInventoryMessage !== '' && (
        <Group direction="horizontal" horizontalAlign="center" verticalAlign="center" gap={4}>
          <LinePlaneDepartureIcon size="XS" colour="light-foreground-alt" />
          <BodyText variant="small" colour="light-foreground-alt">
            {fnfInventoryMessage}
          </BodyText>
        </Group>
      )}
    </SpecialOfferGroup>
  )
}

export default MaldivesFnfSpecialOffer
